const API_URL = import.meta.env.VITE_APP_API_URL;

function getAuthToken() {
  // Primary: auth object
  const auth = localStorage.getItem('auth');
  if (auth) {
    try {
      const parsed = JSON.parse(auth);
      if (parsed?.token) return parsed.token;
    } catch {}
  }

  // Optional fallbacks (safe, won’t break anything)
  return localStorage.getItem('accessToken') || localStorage.getItem('token') || null;
}

export async function apiFetch(url, options = {}) {
  const token = getAuthToken();
  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(isFormData ? {} : { 'Content-Type': 'application/json' })
  };

  const res = await fetch(`${API_URL}${url}`, {
    ...options,
    headers
  });

  // ✅ FIX 1: use "res", not "response"
  if (res.status === 401) {
    // Helpful error text (if backend sends it)
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Unauthorized');
  }

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    // ✅ FIX 2: use backend response text, not "err.message"
    throw new Error(text || 'API Error');
  }

  // ✅ FIX 3: parse only if JSON
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return res.json();
  }

  // For empty/non-json responses (like some upload endpoints)
  return res.text();
}

